import ViewInventory from "../../../../components/@operations/inventory/ViewInventory"

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ViewInventoryPage() {

    return (
        <ViewInventory
            routeType={routeTypes.workstation}
        />
    )
}       